import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Dropdown, Item } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';

class Customer extends React.Component {

  state = {
    customerOption: []
  }

  componentDidMount() {
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    context.setState({ load: true, message: 'Getting Customer type' })
    let cook = (ReadCookie("vaigai"));
    let executiveId = cook.id;
    $.ajax({
      type: 'POST', data: { executiveId },
      url: Server() + 'customer/getallcustomer.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setAllCustomerType(data);
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setAllCustomerType(data) {
    let context = this;
    var customer = [];
    data.map((y) => {
      let text = y.id+"-->"+y.name+"->"+y.taluk;
      customer.push({key: text, text: text, value: y.id});
    });
    this.setState({ customerOption: customer, customers: data, load: false });
  }

  customers = event => {
    let value = event.target.value;
    try {
        value = value.split('-->')[0]; 
    } catch (error) {
        value = 0;
    }
    if (!value || isNaN(value)) {
      this.props.update('', this.state.customers);
      return;
    }
    this.props.update(value, this.state.customers);
  }

    render() {
        let { customerOption } = this.state;
        return (
            <div>
                <input onChange={this.customers} list="customers" style={{height: '25px', width: '100%'}} />
                <datalist id="customers">
                    { 
                        customerOption.map((item) => {
                            return <option value={item.text} />
                        })
                    }
                </datalist>
            </div>
        );
    }
}

export default Customer;
